import { PermitFieldType } from '~/client/graph/types.generated'

export const REQUIRED_FIELD_TYPES: PermitFieldType[] = [
  PermitFieldType.StartFinishDates,
  PermitFieldType.Assignee,
  PermitFieldType.Company,
]
